import React from "react";
import { useTranslation } from "react-i18next";

import SmallScreen from "~/components/Icons/svg/smallScreen";
import { ChartBarIvideon, CircleChart } from "~/components/Chart";
import { getPercentages } from "~/pages/IvideonDealerSummary2/helper";
import { faceVariablesIProps } from "~/pages/IvideonDealerSummary2/options";

import styles from "~/pages/IvideonDealerSummary2/IvideonDealerSummary.less";

interface ItemChartPeople {
  dataBar: faceVariablesIProps;
  handleVariant: (prop: null) => void;
  isLoading: boolean;
}

const ItemChartPeople = ({
  dataBar,
  handleVariant,
  isLoading,
}: ItemChartPeople) => {
  const { t } = useTranslation();
  const isCircle = dataBar.type === "circle";

  return (
    <>
      <div className={styles.cardGraph}>
        <div className={styles.cardTitleWrapper}>
          <span className={styles.cardTitle}>{dataBar.title}</span>
          <div className={styles.itemTitleWrapper}>
            {dataBar.variant === "gender" && (
              <>
                <div className={styles.itemTitle}>
                  <div className={styles.colorItemBlue}></div>
                  <span>мужчины</span>
                </div>
                <div className={styles.itemTitle}>
                  <div className={styles.colorItemOrange}></div>
                  <span>женщины</span>
                </div>
              </>
            )}
            {dataBar.variant === "newFaces" && (
              <>
                <div className={styles.itemTitle}>
                  <div className={styles.colorItemOrange}></div>
                  <span>Уникальные</span>
                </div>
                <div className={styles.itemTitle}>
                  <div className={styles.colorItemGreen}></div>
                  <span>Новые</span>
                </div>
              </>
            )}
            {dataBar.variant === "returningFaces" && (
              <>
                <div className={styles.itemTitle}>
                  <div className={styles.colorItemOrange}></div>
                  <span>Уникальные</span>
                </div>
                <div className={styles.itemTitle}>
                  <div className={styles.colorItemGray}></div>
                  <span>Повторные</span>
                </div>
              </>
            )}
            <div
              className={styles.wrappIcon}
              onClick={() => handleVariant(null)}
            >
              <SmallScreen />
            </div>
          </div>
        </div>
        {isCircle ? (
          <div className={styles.circleExpandedLayout}>
            {dataBar.variant === "age" && (
              <div className={styles.wrapperLabelsCircle}>
                {dataBar.circleDataConfig?.map((cfg, i) => {
                  const allValues = dataBar.circleDataConfig!.map(
                    (c) => c.value,
                  );
                  return (
                    <div key={i} className={styles.itemLabelCircle}>
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          background: cfg.color,
                        }}
                      ></div>
                      <div>
                        {cfg.label}({getPercentages(allValues, cfg.value)})
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {dataBar.variant === "emotion" && (
              <div className={styles.wrapperLabelsCircleEmotion}>
                {dataBar.circleDataConfig?.map((cfg, i) => {
                  return (
                    <div key={i} className={styles.itemLabelCircle}>
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          background: cfg.color,
                        }}
                      ></div>
                      <div>
                        {t(`analytica.${cfg.key}`)} <span>{cfg.value}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <CircleChart
              key={dataBar.variant}
              data={
                dataBar.circleDataConfig?.some((c) => c.value > 0)
                  ? [dataBar.circleDataConfig!.map((c) => c.value)]
                  : []
              }
              label={dataBar.circleDataConfig!.map((c) => c.label)}
              circleColorList={dataBar.circleDataConfig!.map((c) => c.color)}
              chartContainer={styles.chartContainer}
              isLoading={isLoading}
              size={{ width: "1000px", height: "500px" }}
            />
          </div>
        ) : (
          <ChartBarIvideon
            chartContainer={styles.chartContainer}
            data={dataBar.data!}
            label={dataBar.label}
            isLoading={isLoading}
            dataContentInfoCardCar={dataBar.dataContentInfoCardCar!}
            mainColor={dataBar.mainColor}
            secondaryColor={dataBar.secondaryColor}
            secondaryColor2={dataBar.secondaryColor2}
          />
        )}
      </div>
    </>
  );
};

export default ItemChartPeople;
